<ng-container>

  <app-spinner [promise]="this.scheduleChangeoverPromise"></app-spinner>

  <mat-horizontal-stepper #stepper
                          *ngIf="!this.scheduleChangeoverPromise"
                          labelPosition="bottom"
                          class="steps">

    <mat-step #step1
              [completed]="this.selectedDate && this.selectedTime"
              state="datetime">
      <div class="step-body">
        <div class="form">
          <ng-template matStepLabel>Date & Time</ng-template>
          <mat-form-field appearance="fill">
            <mat-label>Choose a date</mat-label>
            <input matInput
                   [(ngModel)]="this.selectedDate"
                   [matDatepicker]="datePicker"
                   (click)="datePicker.open()"
                   readonly
                   required>
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Choose a time</mat-label>
            <input matInput
                   [(ngModel)]="this.selectedTime"
                   type="time"
                   [attr.step]="60 * 15"
                   required>
          </mat-form-field>
        </div>

        <div class="flex-spacer"></div>

        <div class="navigation">
          <span class="flex-spacer"></span>
          <button mat-button matStepperNext>
            NEXT
            <mat-icon>arrow_forward_ios</mat-icon>
          </button>
        </div>
      </div>
    </mat-step>


    <mat-step #step2
              [completed]="!!this.selectedChangeoverType"
              state="type">
      <ng-template matStepLabel>Changeover Type</ng-template>
      <div class="step-body step2">
        <app-spinner [promise]="this.getChangeoverTypesPromise"></app-spinner>

        <div *ngIf="!this.getChangeoverTypesPromise">
          <div class="form">
            <mat-form-field>
              <mat-label>From</mat-label>
              <mat-select [(value)]="this.selectedFromId" required>
                <mat-option *ngFor="let product of this.fromOptions" [value]="product.id">
                  {{product.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>To</mat-label>
              <mat-select [(value)]="this.selectedToId" required [disabled]="!this.selectedFromId">
                <mat-option *ngFor="let product of this.getToOptions()" [value]="product.id">
                  {{product.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form">
            <mat-form-field>
              <mat-label>Changeover Type</mat-label>
              <mat-select [(value)]="this.selectedChangeoverType" required [disabled]="!this.selectedToId">
                <mat-option *ngFor="let type of this.getChangeoverTypeOptions()" [value]="type">
                  {{type.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="flex-spacer"></div>

        <div class="navigation">
          <button mat-button matStepperPrevious>
            <mat-icon>arrow_back_ios</mat-icon>
            PREVIOUS
          </button>

          <span class="flex-spacer"></span>

          <button mat-button matStepperNext>
            NEXT
            <mat-icon>arrow_forward_ios</mat-icon>
          </button>
        </div>
      </div>
    </mat-step>


    <mat-step #step3
              [completed]="step1.completed && step2.completed"
              state="preview">
      <div class="step-body">
        <ng-template matStepLabel>Preview</ng-template>
        <div class="form">
          <p *ngIf="!step3.completed" class="error">
            <mat-icon>error</mat-icon>All steps must be completed.
          </p>

          <ng-container *ngIf="step3.completed;">
            <div class="preview-item">
              <div class="custom-label">Date</div>
              <p>{{this.formattedDate}}</p>
            </div>
            <div class="preview-item">
              <div class="custom-label">Time</div>
              <p>{{this.selectedTime}}</p>
            </div>

            <ng-container *ngIf="this.selectedChangeoverType; let type;">
              <div class="preview-item">
                <div class="custom-label">Type</div>
                <p>{{type.name}}</p>
              </div>
              <div class="preview-item task-list">
                <div class="custom-label">Tasks</div>
                <div>
                  <ol>
                    <li *ngFor="let task of type.tasks">{{task}}</li>
                  </ol>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="flex-spacer"></div>

        <div class="navigation">
          <button mat-button matStepperPrevious>
            <mat-icon>arrow_back_ios</mat-icon>
            PREVIOUS
          </button>
          <span class="flex-spacer"></span>
          <button mat-raised-button
                  color="primary"
                  [disabled]="!this.step3.completed"
                  (click)="this.scheduleChangeover()">
            SCHEDULE
          </button>
        </div>
      </div>
    </mat-step>


    <ng-template matStepperIcon="datetime">
      <mat-icon>calendar_today</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="type">
      <mat-icon>trending_flat</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="preview">
      <mat-icon>done_all</mat-icon>
    </ng-template>
  </mat-horizontal-stepper>

</ng-container>